import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export const emailValidator = Validators.pattern(
  '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$'
);
